module.exports = __webpack_public_path__ + "img/categorie-epicerie-famille-boutrais.38c89de9.jpg";